export function getTimeStamps(fps: any, totalFrames: any) {
  const frameTimestamps = [];

  for (let i = 0; i < totalFrames; i++) {
    const timestamp = (1 / fps) * i;
    frameTimestamps.push(timestamp);
  }

  return frameTimestamps;
}

let VIDEO_HEIGHT = window.screen.availHeight;

export function getVideoRatio(height: any, grace = 0, isNumber = false) {
  if (height) {
    VIDEO_HEIGHT = height;
  }

  const heightLocal = height || VIDEO_HEIGHT;

  const finalWidth = Math.floor((heightLocal * 9) / 16) - grace;
  if (isNumber) {
    return finalWidth;
  }
  return finalWidth + "px";
}
export function getVideoRatio1({
  height,
  videoHeight,
  videoWidth,
  grace = 0,
  isNumber = false,
}: any) {
  if (height) {
    VIDEO_HEIGHT = height;
  }

  const heightLocal = height || VIDEO_HEIGHT;
  const finalWidth =
    Math.floor((heightLocal * videoHeight) / videoWidth) - grace;
  if (isNumber) {
    return finalWidth;
  }
  return finalWidth + "px";
}
export function getVideoRatioDynamic(
  { height, videoHeight = 1920, videoWidth = 1080 }: any,
  grace = 0,
  isNumber = false,
) {
  if (height) {
    VIDEO_HEIGHT = height;
  }

  const heightLocal = height || VIDEO_HEIGHT;
  const finalWidth =
    Math.floor((heightLocal * videoWidth) / videoHeight) - grace;
  if (isNumber) {
    return finalWidth;
  }

  return finalWidth + "px";
}
export function getWidthDynamic(
  { height, videoHeight = 1920, videoWidth = 1080 }: any,
  grace = 0,
  isNumber = false,
) {
  if (height) {
    VIDEO_HEIGHT = height;
  }

  const heightLocal = height || VIDEO_HEIGHT;
  const finalWidth =
    Math.floor((heightLocal * videoWidth) / videoHeight) - grace;
  if (isNumber) {
    return finalWidth;
  }

  return finalWidth + "px";
}
